<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="应付总账"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            size="mini"
            clearable
            v-model="params.GoodsName"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="供应商">
          <supplier @restaurants="setSupplier" :state="params.SupplierName" />
        </el-form-item>
        <template>
          <el-form-item label="单据日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        </template>
      </template>
      <template slot="table">
        <el-table-column label="单据编号" prop="DocNo" />
        <el-table-column label="业务员" prop="ClerkName" />
        <el-table-column label="预计金额" prop="Amount" />
        <el-table-column label="日期" prop="DocDate">
          <template slot-scope="{ row }">
            {{ row.DocDate.split(" ")[0] }}
          </template>
        </el-table-column>
        <el-table-column label="采购单状态" prop="Status" width="120">
          <template slot-scope="{ row }">
            {{ row.Status == 0 ? "未生成" : "已生成" }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="Remark" width="200" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <class-dialog
      ref="classDialog"
      selectable
      multiple
      @select="setClass"
      title="商品分类"
    />
    <supplier-dialog
      ref="supplierDialog"
      in-dialog
      selectable
      @select="setSupplier"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import classDialog from "@/components/basicinfo/goods/archives/goodsTree/listDialog";
import supplierDialog from "@/components/purchase/supplier/archives/listDialog";
import supplier from "@/components/common/supplier/supplier";
export default {
  mixins: [listMixin],
  components: { list, classDialog, supplierDialog, supplier },
  data() {
    return {
      api: require("@/api/purchase/predict").default,
      exp_api: require("@/api/purchase/return").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      supplierList: [],
      params: {
        GoodsName: "",
        DocNo: "",
        DocDateStart: "",
        DocDateEnd: "",
        IdChain: "",
        ClassName: "",
        ClerkId: "",
        ClerkName: "",
        SupplierId: "",
        SupplierName: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.dpapi.list({}).then((res) => {
      let list = [];
      res.Data.forEach((e) => {
        list.push({ value: e.SupplierName, Id: e.SupplierId });
      });
      this.supplierList = list;
    });
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    setSupplier(data) {
      console.log(data);
      this.params.SupplierId = data.TradeUnitId;
      this.params.SupplierName = data.TradeUnitName;
    },
    handleSelect(item) {
      this.params.SupplierName = item.value;
      this.params.SupplierId = item.Id;
    },
    querySearchAsync(queryString, cb) {
      var supplierList = this.supplierList;
      var results = queryString
        ? supplierList.filter(this.createStateFilter(queryString))
        : supplierList;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        if (state.value) {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        }
      };
    },
    onExport() {
      this.exp_api.export(this.params);
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId;
      this.data.ClerkName = e.EmpName;
    },
    setClass(data) {
      this.params.IdChain = data.IdChain;
      this.params.ClassName = data.ClassName;
    },
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ Status: 1, ClassType: 6 });
      });
    },

    openSupplierDialog() {
      this.$refs.supplierDialog.open().then((that) => {
        that.getData();
        that.getTree();
      });
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>